import BaseCollection from "lib/collection";
import Company from "models/company";

export default BaseCollection.extend({
    url: "/api/v3.0/companies",

    model(attrs, options) {
        const Model = options.collection.getSchemaModel(attrs.__schema_id);
        return new Model(attrs, options);
    },

    getSchemaModel(schemaId) {
        const schema = this.parent ? this.parent.schemas.get(schemaId) : null;
        if (schema) {
            return schema.getModel();
        } else {
            return Company;
        }
    },

    isModel: function (model) {
        return model instanceof this.getSchemaModel(model.schema_id);
    },
});
